(function () {
  'use strict';

  // Same double-init guard the other shared luxe scripts use, since every
  // showcase section emits the asset tags.
  if (window.LuxeDuo) return;
  window.LuxeDuo = true;

  var roots = Array.prototype.slice.call(document.querySelectorAll('[data-luxe-duo]'));
  if (!roots.length) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Nothing below is required for the images to be readable — the stylesheet
  // renders them fully visible and statically cropped on its own, and only
  // opts into motion once this class is on. So a JS failure degrades to a
  // plain pair of pictures rather than a blank gap.
  if (reduce || !window.LuxeScroll) return;

  roots.forEach(function (root) { root.classList.add('luxe-duo--anim'); });

  var figures = [];
  var items = [];

  roots.forEach(function (root) {
    Array.prototype.slice.call(root.querySelectorAll('[data-duo-figure]')).forEach(function (fig) {
      figures.push(fig);
    });
    Array.prototype.slice.call(root.querySelectorAll('[data-duo-media]')).forEach(function (media) {
      items.push({
        media: media,
        frame: media.parentNode,
        depth: parseFloat(media.getAttribute('data-duo-depth')) || 0,
        shift: 0,
        applied: null,
        active: false
      });
    });
  });

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        entries[i].target.classList.add('is-visible');
        io.unobserve(entries[i].target);
      }
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });
    figures.forEach(function (fig) { io.observe(fig); });
  } else {
    figures.forEach(function (fig) { fig.classList.add('is-visible'); });
  }

  if (!items.length) return;

  // Share of frame height each image may travel. Must stay in step with
  // --duo-travel in luxe-duo.css, which grows the media box by the same
  // amount top and bottom so the shift never uncovers an edge.
  var TRAVEL = 0.08;

  // Registered with the shared scroll driver rather than binding its own
  // scroll handler: the driver batches every consumer's reads before any of
  // their writes, so adding this costs no extra layout pass.
  window.LuxeScroll.register({
    measure: function (state) {
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        var r = it.frame.getBoundingClientRect();

        it.active = r.bottom > -120 && r.top < state.vh + 120;
        if (!it.active) continue;

        // -1 as the frame enters from below, +1 as it leaves past the top.
        var mid = r.top + (r.height / 2);
        var t = ((state.vh / 2) - mid) / ((state.vh + r.height) / 2);
        if (t < -1) t = -1;
        else if (t > 1) t = 1;

        // Positive as the page scrolls down, so the image drifts downward
        // inside its frame — i.e. rises more slowly than the frame itself.
        it.shift = t * (r.height * TRAVEL) * it.depth;
      }
    },
    paint: function () {
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        if (!it.active) continue;
        var v = Math.round(it.shift * 100) / 100;
        if (v === it.applied) continue;
        it.applied = v;
        it.media.style.transform = 'translate3d(0,' + v + 'px,0)';
      }
      return false;
    }
  });
})();
